import React from "react";
import BizAirportDrodown from "./BizAirportDropdown";
import { useDestinationContext } from "../../contexts/DestinationContext";
import styled from "styled-components";
import InputDatePicker from "./Datepicker";
import TravelTimeSelect from "./TravelTimeSelect";
import PreferredAirlines from "./PreferredAirLines";
import Dropdown from "./DropdownField";
import DropdownTravelClass from "./DropdownTravelClass";
import DropdownFlightType from "./DropdownFlightType";
import DateRangePickerInput from "./DateRangePickerInput";
import InputField from "./InputField";
import DateRangeErrorBoundary from "./DateRangePickerInput/Boundary";

const TravelDetailsForm = ({
  flightTypes,
  data,
  onFlightTypeSelect,
  onAirportSelect,
  onTimeRangeSelect,
  onCheckAirlines,
  onDateSelection,
  errors,
  selectedLeave,
  onPrivilegeChange,
  privilegeCard,
  activeTripType,
  // minStartDate,
  // maxEndDate,
}) => {
  const { destinations } = useDestinationContext();
  let minStartDate = new Date(selectedLeave?.startDate);
  let maxEndDate;
  if (activeTripType === "Multi City") {
    maxEndDate = new Date(selectedLeave?.endDate);
    maxEndDate.setDate(maxEndDate.getDate() + 5);
  } else {
    if (data?.type === "Round Trip") {
      maxEndDate = new Date(selectedLeave?.endDate);
      maxEndDate.setDate(maxEndDate.getDate() + 5);
    } else {
      maxEndDate = new Date(selectedLeave?.startDate);
      maxEndDate.setDate(maxEndDate.getDate());
    }
  }

  minStartDate.setDate(minStartDate.getDate() - 5);
  return (
    <FormContainer>
      <RowWrapper>
        <DropdownWrapper>
          <BizAirportDrodown
            value={destinations?.filter((de) => data?.from === de.value)[0]}
            name="from"
            data={destinations}
            icon={require("../../assets/images/biz_onboard.png")}
            label={"From"}
            onSelect={onAirportSelect}
            helperText={errors?.["from"]}
            required={true}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <BizAirportDrodown
            value={destinations?.filter((de) => data?.to === de.value)[0]}
            name="to"
            data={destinations}
            icon={require("../../assets/images/biz_destination.png")}
            label={"To"}
            onSelect={onAirportSelect}
            helperText={errors?.["to"]}
            required={true}
          />
        </DropdownWrapper>
      </RowWrapper>
      <RowWrapper>
        <DateFieldContainer>
          {data?.type === "Round Trip" ? (
            <DateRangeErrorBoundary>
              <DateRangePickerInput
                label="Departure & Return Date"
                onDateSelection={onDateSelection}
                start={data?.departureDate}
                end={data?.returnDate}
                minDate={minStartDate}
                maxDate={maxEndDate}
                helperText={errors?.["date"]}
                autoMinMaxSelect={false}
                disabled={!selectedLeave?.startDate || !selectedLeave?.endDate}
                required={true}
              />
            </DateRangeErrorBoundary>
          ) : (
            <InputDatePicker
              format="ccc dd-MM-yyyy"
              placeholder="Select Preferred Date"
              label="Departure Date"
              value={data?.departureDate ? new Date(data?.departureDate) : ""}
              onChange={(val) => onDateSelection(val)}
              minDate={minStartDate}
              maxDate={maxEndDate}
              scrollableYearDropdown
              scrollableMonthDropdown
              dropdownMode="select"
              hideIcon
              placeHolderColor
              helperText={errors?.["date"]}
              disabled={!selectedLeave?.startDate || !selectedLeave?.endDate}
              required={true}
            />
          )}
        </DateFieldContainer>
        <DropdownWrapper>
          <TravelTimeSelect
            helperText={errors?.["time"]}
            returnTime={data?.returnTime}
            departureTime={data?.departureTime}
            returnJourney={data?.type === "Round Trip"}
            onTimeRangeSelect={onTimeRangeSelect}
            required
          />
        </DropdownWrapper>
      </RowWrapper>
      <RowWrapper>
        <DropdownWrapper>
          <PreferredAirlines
            airlines={data?.preferredAirlines}
            // onClassSelect={setTravelClass}
            onCheck={onCheckAirlines}
            // helperText={fieldError.perferAirline}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Dropdown
            label="Flight Type"
            topOffset="72px"
            value={data?.flightType}
            error={errors?.["flightType"]}
          >
            <DropdownFlightType
              flightTypes={flightTypes}
              selected={data?.flightType}
              onFlightTypeSelect={onFlightTypeSelect}
            />
          </Dropdown>
        </DropdownWrapper>
      </RowWrapper>
      <RowWrapper2>
        <DropdownWrapper>
          <InputField
            isRounded={true}
            label="Privilege Club"
            required={false}
            value={privilegeCard}
            placeholder="Privilege Club"
            name={"privilegeClub"}
            onChange={onPrivilegeChange}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <div></div>
        </DropdownWrapper>
      </RowWrapper2>
    </FormContainer>
  );
};

export default TravelDetailsForm;

const DateFieldContainer = styled.div`
  flex: 1;
`;

const FormContainer = styled.div``;

const DropdownWrapper = styled.div`
  flex: 1;
`;

const RowWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

const RowWrapper2 = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  margin-top: 0.5rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;
